<template>
  <!-- Add -->
  <b-modal
    :id="'SelectCam' + idData"
    ref="my-modal"
    title="เลือกกล้อง"
    size="xl"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @ok="handleSubmit"
  >
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <div>
          <vue-good-table
            :columns="computedFields"
            :rows="items"
            theme="nocturnal"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
            }"
            :pagination-options="{
              enabled: true,
              perPage:pageLength
            }"
            @on-selected-rows-change="handleSelectionChange"
          >
            <template
              slot="table-row"
              slot-scope="props"
            >
              <span v-if="props.column.field === 'Camera_Desc'">
                {{ props.row.Camera_Desc }}
              </span>
              <!-- Column: Status -->
              <span v-if="props.column.field === 'checkipaddress'">
                <b-badge :variant="status[1][props.row.checkipaddress]">
                  {{ status[0][props.row.checkipaddress] }}
                </b-badge>
              </span>
              <span v-if="props.column.field === 'live'">
                <b-link
                  v-if="props.row.RTSP_HLS"
                  v-b-modal="'Live'"
                  @click="$refs.RTSP.streamLive(props.row.RTSP_HLS)"
                >
                  <b-img
                    src="@/assets/images/icons/Live.svg"
                  />
                </b-link>
              </span>
              <span v-if="props.column.field === 'PhaseNo' && type_name === 'Traffic'">
                <b-form-select
                  v-model="props.row.PhaseNo"
                  :options="optionsPhase"
                >
                  <template #first>
                    <b-form-select-option
                      :value="null"
                      disabled
                      selected
                    >-- กรุณาเลือก Phase --</b-form-select-option>
                  </template>
                </b-form-select>
              </span>
              <span v-if="props.column.field === 'IsStopLine' && type_name === 'Traffic'">
                <b-form-select
                  v-model="props.row.IsStopLine"
                  :options="optionsIsStopLine"
                >
                  <!-- This slot appears above the options from 'options' prop -->
                  <template #first>
                    <b-form-select-option
                      :value="null"
                      disabled
                      selected
                    >-- กรุณาเลือกการใช้งาน --</b-form-select-option>
                  </template>
                </b-form-select>
              </span>
              <!-- traffic sign -->
              <span v-if="props.column.field === 'image_time' && type_name === 'TrafficSign'">
                <b-form-input
                  id="hls_url"
                  v-model="props.row.image_time"
                  type="text"
                  placeholder="https://example.com/stream.m3u8"
                />
              </span>
              <span v-if="props.column.field === 'traffic_sign_cam1' && type_name === 'TrafficSign'">
                <b-form-input
                  id="hls_url"
                  v-model="props.row.traffic_sign_cam1"
                  type="text"
                  placeholder="https://example.com/stream.m3u8"
                />
              </span>
              <span v-if="props.column.field === 'traffic_sign_cam2' && type_name === 'TrafficSign'">
                <b-form-input
                  id="hls_url"
                  v-model="props.row.traffic_sign_cam2"
                  type="text"
                  placeholder="https://example.com/stream.m3u8"
                />
              </span>
            </template>

            <!-- pagination -->
            <template
              slot="pagination-bottom"
              slot-scope="props"
            >
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap ">
                    Showing 1 to
                  </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['100']"
                    class="mx-1"
                    @input="(value)=>props.perPageChanged({currentPerPage:value})"
                  />
                  <span class="text-nowrap"> of {{ props.total }} entries </span>
                </div>
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value)=>props.pageChanged({currentPage:value})"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>
        </div>
      </b-col>
    </b-row>

    <Live
      ref="RTSP"
    />
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormSelect, BPagination, BBadge,
  BImg, BLink, BFormSelectOption, BFormInput,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Live from './Live1.vue'

export default {
  components: {
    BRow,
    BCol,
    VueGoodTable,
    BFormSelect,
    BPagination,
    BFormSelectOption,
    BBadge,
    BImg,
    BLink,
    BFormInput,
    Live,
  },
  props: {
    idData: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      pageLength: 100,
      dir: false,
      fields: [],
      items: [],
      data: [],
      dataUse: [],
      selectMode: 'multi',
      optionsIsStopLine: [{ text: 'นับรถ', value: '0' }, { text: 'ST-Line', value: '1' }],
      optionsPhase: [{ text: 'Phase 1', value: '1' }, { text: 'Phase 2', value: '2' }, { text: 'Phase 3', value: '3' }, { text: 'Phase 4', value: '4' },
        { text: 'Phase 5', value: '5' }, { text: 'Phase 6', value: '6' }, { text: 'Phase 7', value: '7' }, { text: 'Phase 8', value: '8' },
      ],
      selected: [],
      wid: '',
      type_name: '',
      status: [{
        1: 'ถูกใช้แล้ว', 0: 'ยังไม่ใช้',
      },
      {
        1: 'success', 0: 'danger',
      }],
    }
  },
  computed: {
    computedFields() {
    // Default fields
      const fields = [
        {
          field: 'Camera_Desc',
          label: 'Hostname',
          thClass: 'text-center',
        },
        {
          field: 'checkipaddress',
          label: 'สถานะถูกใช้',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'live',
          label: 'Live',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]

      // 'Traffic'
      if (this.type_name === 'Traffic') {
        fields.push({
          field: 'IsStopLine',
          label: 'การใช้งาน',
          thClass: 'text-center',
          tdClass: 'text-center',
        })
      }
      if (this.type_name === 'Traffic') {
        fields.push({
          field: 'PhaseNo',
          label: 'Phase',
          thClass: 'text-center',
          tdClass: 'text-center',
        })
      }
      // 'TrafficSign'
      if (this.type_name === 'TrafficSign') {
        fields.push({
          field: 'image_time',
          label: 'ภาพหน้าจอโปรแกรม',
        })
      }
      if (this.type_name === 'TrafficSign') {
        fields.push({
          field: 'traffic_sign_cam1',
          label: 'กล้องส่องป้ายที่ 1',
        })
      }
      if (this.type_name === 'TrafficSign') {
        fields.push({
          field: 'traffic_sign_cam2',
          label: 'กล้องส่องป้ายที่ 2',
        })
      }

      return fields
    },
  },

  mounted() {
  },
  methods: {
    handleSubmit() {
      this.addInfo()
    },
    addInfo() {
      this.data.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.id = this.wid
        // eslint-disable-next-line no-param-reassign
        item.type_name = this.type_name
      })
      switch (true) {
        case (this.data.length > 0 && this.type_name === 'Traffic'):
          this.data.forEach(item => {
            if (item.PhaseNo !== null && item.PhaseNo !== undefined && item.IsStopLine !== null && item.IsStopLine !== undefined) {
              axios
                .post('/selectCamera', { data: this.data })
                .then(response => {
                  console.log(response)
                  this.$swal({
                    icon: 'success',
                    title: '<span style="color:#000000">เพิ่มกล้องเรียบร้อย.</span>',
                    showConfirmButton: false,
                    timer: 1000,
                  })
                  this.$nextTick(() => {
                    this.$bvModal.hide(`SelectCam${this.idData}`)
                  })
                  this.$emit('fetch')
                })
                .catch(error => {
                  console.log(error)
                })
            } else {
              this.$swal({
                icon: 'warning',
                title: '<span style="color:#000000">กรุณาเลือก Phase และ การใช้งาน</span>',
                showConfirmButton: false,
                timer: 2000,
              })
              this.data = []
              this.$nextTick(() => {
                this.$bvModal.show(`SelectCam${this.idData}`)
              })
            }
          })
          break
        case (this.data.length > 0 && this.type_name === 'TrafficSign'):
          this.data.forEach(item => {
            if ((item.image_time !== null && item.image_time !== undefined && item.traffic_sign_cam1 !== null && item.traffic_sign_cam1 !== undefined)) {
              const pattern = /^https:\/\/.*\.m3u8$/i
              const imagetime = pattern.test(item.image_time)
              const trafficsigncam1 = pattern.test(item.traffic_sign_cam1)
              if (imagetime && trafficsigncam1) {
                axios
                  .post('/selectCamera', { data: this.data })
                  .then(response => {
                    console.log(response)
                    this.$swal({
                      icon: 'success',
                      title: '<span style="color:#000000">เพิ่มกล้องเรียบร้อย.</span>',
                      showConfirmButton: false,
                      timer: 1000,
                    })
                    this.$nextTick(() => {
                      this.$bvModal.hide(`SelectCam${this.idData}`)
                    })
                    this.$emit('fetch')
                  })
                  .catch(error => {
                    console.log(error)
                  })
              } else {
                this.$swal({
                  icon: 'warning',
                  title: '<span style="color:#000000">ข้อมูลไม่ถูกต้อง</span>',
                  showConfirmButton: false,
                  timer: 2000,
                })
                this.$nextTick(() => {
                  this.$bvModal.show(`SelectCam${this.idData}`)
                })
              }
            } else {
              this.$swal({
                icon: 'warning',
                title: '<span style="color:#000000">ใส่ข้อมูลไม่ครบ</span>',
                showConfirmButton: false,
                timer: 2000,
              })
              this.data = []
              this.$nextTick(() => {
                this.$bvModal.show(`SelectCam${this.idData}`)
              })
            }
          })
          break
        case (this.data.length > 0 && this.type_name === 'CCTV'):
          axios
            .post('/selectCamera', { data: this.data })
            .then(response => {
              console.log(response)
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">เพิ่มกล้องเรียบร้อย.</span>',
                showConfirmButton: false,
                timer: 1000,
              })
              this.$nextTick(() => {
                this.$bvModal.hide(`SelectCam${this.idData}`)
              })
              this.$emit('fetch')
            })
            .catch(error => {
              console.log(error)
            })
          break
        case (this.data.length > 0 && this.type_name === 'Counting7'):
          axios
            .post('/selectCamera', { data: this.data })
            .then(response => {
              console.log(response)
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">เพิ่มกล้องเรียบร้อย.</span>',
                showConfirmButton: false,
                timer: 1000,
              })
              this.$nextTick(() => {
                this.$bvModal.hide(`SelectCam${this.idData}`)
              })
              this.$emit('fetch')
            })
            .catch(error => {
              console.log(error)
            })
          break
        case (this.data.length > 0 && this.type_name === 'Analytic'):
          axios
            .post('/selectCamera', { data: this.data })
            .then(response => {
              console.log(response)
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">เพิ่มกล้องเรียบร้อย.</span>',
                showConfirmButton: false,
                timer: 1000,
              })
              this.$nextTick(() => {
                this.$bvModal.hide(`SelectCam${this.idData}`)
              })
              this.$emit('fetch')
            })
            .catch(error => {
              console.log(error)
            })
          break
        default:
        // yada yada
      }
    },
    getSumEquipment(id, type) {
      this.wid = id
      this.type_name = type
      axios
        .post('/tableEquipment', { pj_code: this.$route.query.pj_code })
        .then(response => {
          this.items = response.data
          if (this.modalID) {
            this.fetchLocation()
          }
          this.items = this.items.map(item => ({
            ...item,
            PhaseNo: item.PhaseNo !== undefined && item.PhaseNo !== null ? item.PhaseNo : null, // ถ้ามีค่าใช้ค่านั้น ถ้าไม่มีให้ใส่ null
            IsStopLine: item.IsStopLine !== undefined && item.IsStopLine !== null ? item.IsStopLine : null, // ถ้ามีค่าใช้ค่านั้น ถ้าไม่มีให้ใส่ null
          }))
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSelectionChange({ selectedRows }) {
      this.data = selectedRows
      console.log(this.data)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-th-class{
  align-items: center
}
</style>
